export function isEqualFlatObjects(a: object, b: object): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}
